import { IInformacionProyectos } from "../interfaces/InformacionProyectos"
import { loadingStart, loadingStop, notifyError } from "./notiflixHelpers"


//Si se deben pasar parámetros con valores se debe generar la función en el componente
export const genericListLoader = (func: () => Promise<any>, setter: (value: any) => any) => {
    loadingStart()
    var data = func()
    data.then((res) => {
        //console.log(res)
        setter(res)
    })
        .catch((error) => {
            //console.error(error)
            loadingStop()
            notifyError(error, 'Error', 'OK')
        })
    loadingStop()
}

export const genericListLoaderPaged = (
    func: (page: number, search?: string) => Promise<any>,
    setter: (value: any) => any,
    page: number,
    setterPageCount: (value: number) => void,
    search?: string
) => {
    loadingStart()
    var data = func(page, search)
    data.then((res) => {
        //console.log(res)
        setter(res.data)
        setterPageCount(res.pageCount)
    })
        .catch((error) => {
            //console.error(error)
            loadingStop()
            notifyError(error, 'Error', 'OK')
        })
    loadingStop()
}

export const getCookie = (cookieName: string) => {
    let name = `${cookieName}=`
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let index = 0; index < ca.length; index++) {
        let c = ca[index]
        while (c.charAt(0) === ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {

            return c.substring(name.length, c.length)
        }
    }
    return ''
}

export const mapDataInfoProyectos = (data: IInformacionProyectos[]): number[] => {
    return data.map((value) => value.cantidadResultados);
};

export const mapCategoriesInfoProyectos = (
    data: IInformacionProyectos[]
): { name: string; fullname: string }[] => {
    return data.map((value) => {
        const [name, fullname] = value.descripcion.split("/");
        return { name, fullname };
    });
};

export const isNumber = (value:any) => {
    return typeof value === 'number';
}

export const getLastUpdate = (substract:number = 7, lang:string = "es"):string => {
    var d = new Date();         // convert string to Date
    d.setDate(d.getDate() - substract);             // remove 7 days
    var str = d.toLocaleDateString(lang); // format YYYY-MM-DD
    return str;
}